import React from 'react';
import { Layout, Input, Badge, Avatar, Dropdown, Space, Typography } from 'antd';
import { 
  SearchOutlined, 
  BellOutlined, 
  QuestionCircleOutlined, 
  UserOutlined,
  LogoutOutlined,
  SettingOutlined 
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const { Header } = Layout;
const { Text } = Typography;

const TopNavigation = ({ user, onLogout }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  // Handle window resize for mobile detection
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    authService.logout();
    if (onLogout) {
      onLogout();
    }
  };

  const handleMenuClick = ({ key }) => {
    if (key === 'profile') {
      navigate('/dashboard/profile');
    } else if (key === 'settings') {
      navigate('/dashboard/settings');
    } else if (key === 'logout') {
      handleLogout();
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
    },
  ];

  return (
    <Header
      style={{
        background: '#fff',
        padding: isMobile ? '0 12px' : '0 24px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 0,
        right: 0,
        left: isMobile ? 0 : 250, // No left offset on mobile
        zIndex: 99,
        height: '64px',
      }}
    >
      {/* Search Bar */}
      <div style={{ 
        flex: 1, 
        maxWidth: isMobile ? '200px' : '400px',
        display: isMobile ? 'none' : 'block' // Hide search on mobile to save space
      }}>
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
          style={{
            borderRadius: '6px',
            backgroundColor: '#f5f5f5',
            border: 'none',
          }}
        />
      </div>

      {/* Right side - Notifications and User */}
      <Space size="large" style={{ alignItems: 'center' }}>
        {/* Help/Question */}
        <QuestionCircleOutlined 
          style={{ fontSize: '18px', color: '#666', cursor: 'pointer' }}
          title="Help"
        />

        {/* Notifications */}
        <Badge count={1} size="small">
          <BellOutlined 
            style={{ fontSize: '18px', color: '#666', cursor: 'pointer' }}
            title="Notifications"
          />
        </Badge>

        {/* User Profile */}
        <Dropdown
          menu={{ items: userMenuItems, onClick: handleMenuClick }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Space style={{ cursor: 'pointer' }}>
            <Avatar 
              style={{ backgroundColor: '#2E86AB' }}
              {...(user?.name || user?.surname 
                ? { children: `${(user.name || '').charAt(0)}${(user.surname || '').charAt(0)}`.toUpperCase() }
                : { icon: <UserOutlined /> }
              )}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Text strong style={{ fontSize: '14px' }}>
                {user?.name && user?.surname 
                  ? `${user.name} ${user.surname}` 
                  : user?.name || user?.email || 'User'}
              </Text>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                {user?.email || 'user@taplearngo.com'}
              </Text>
            </div>
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
};

export default TopNavigation;